import React, { FC, useContext } from 'react'

import LookBookItem from '../LookBookItem/LookBookItem'
import css from './LookBookList.module.scss'
import Button from '../../common/Button/Button'
import { LookbookContext } from '../../../contexts/lookbookProvider'
import { ButtonTheme } from '../../types'

const LookBookList: FC = () => {
  const { loadMore, items, hasNextPage } = useContext(LookbookContext)

  return (
    <>
      <ul className={css.list}>
        {items?.map((look, index) => {
          return <LookBookItem look={look} key={look.id} index={index} />
        })}
      </ul>
      {hasNextPage && (
        <div className={css.button_wrapper}>
          <Button theme={ButtonTheme.ellipseBig} onClick={() => loadMore()}>
            Еще
          </Button>
        </div>
      )}
    </>
  )
}

export default LookBookList
